import { memo, useState, useCallback } from 'react';
import { View, Text, StyleSheet, Pressable, Image } from 'react-native';
import { ReadOnly, TextUtils } from '../../components';
import { THEME, COLOR } from '../../../constants/styles';

function returnComp(label, value, isVertical = false) {
  if (!value) return null;
  return (
    <ReadOnly
      style={[styles.fieldContainerStyle, !isVertical && styles.fieldContainerStyleHorizontal]}
      label={label}
      value={value}
      flexibleLayout={!isVertical}
    />
  );
}

export default memo((props) => {
  const [isExpanded, setIsExpanded] = useState(!!props.alwaysExpanded);
  const toggleExpanded = useCallback(() => setIsExpanded(!isExpanded), [isExpanded]);

  if (!props.data) return null;

  const moreInfoButton = props.alwaysExpanded ? null : (
    <Pressable
      style={[
        styles.moreInfoBtn,
        !!props.isVerticalLayout ? { alignSelf: 'center' } : { alignSelf: 'flex-start' },
      ]}
      onPress={props.disabled ? null : toggleExpanded}
    >
      <View style={styles.infoCircle}>
        <Text style={[THEME.textBold, { color: 'white', fontSize: 12 }]}>i</Text>
      </View>
      <Text style={[THEME.textBold, { fontSize: 12 }]}>{isExpanded ? 'Less' : 'More'} info</Text>
    </Pressable>
  );

  if (!props.isVerticalLayout) {
    return (
      <View style={[styles.container, isExpanded ? { height: 200 } : { height: 96 }]}>
        <View style={[styles.row, { borderBottomWidth: 1, ...THEME.inputContainerDisabled }]}>
          <View style={{ flex: 0.28 }}>{returnComp('First Name', props.data.firstName)}</View>
          <View style={{ flex: 0.24, flexDirection: 'row' }}>
            {returnComp('Last Name', props.data.lastName)}
          </View>
          <View style={{ flex: 0.24, flexDirection: 'row' }}>
            {returnComp('DOW ID', props.data.dodId)}
          </View>
          <View style={{ flex: 0.24, flexDirection: 'row' }}>{moreInfoButton}</View>
        </View>
        <View style={[styles.row]}>
          <View style={{ flex: 0.28, flexDirection: 'row' }}>
            {returnComp('Email', props.data.email)}
          </View>

          <View style={{ flex: 0.24, flexDirection: 'row' }}>
            {returnComp('Status', props.data.status)}
          </View>
          <View style={{ flex: 0.24, flexDirection: 'row' }}>
            {returnComp(
              'Service Branch',
              props.data.serviceBranch ? TextUtils.ce(props.data.serviceBranch) : null
            )}
          </View>
          <View style={{ flex: 0.24, flexDirection: 'row' }}>
            {returnComp('Rank', props.data.rank)}
          </View>
        </View>
      </View>
    );
  }
  return (
    <View style={{ backgroundColor: 'rgb(248, 248, 248)' }}>
      <View style={[styles.container, isExpanded ? { height: 'auto' } : { height: 250 }]}>
        {returnComp('First Name', props.data.firstName, true)}
        {returnComp('Last Name', props.data.lastName, true)}
        {returnComp('DOW ID', props.data.dodId, true)}
        {returnComp('Email', props.data.email, true)}
        {returnComp('Status', props.data.status, true)}
        {returnComp(
          'Service Branch',
          props.data.serviceBranch ? TextUtils.ce(props.data.serviceBranch) : null,
          true
        )}
        {returnComp('Rank', props.data.rank, true)}
      </View>
      {moreInfoButton}
    </View>
  );
});

const styles = StyleSheet.create({
  fieldContainerStyle: {},
  fieldContainerStyleHorizontal: {
    flex: 1,
    marginRight: 10,
    borderBottomWidth: 0,
  },
  row: {
    ...THEME.basicRow,
    paddingVertical: 10,
  },
  container: {
    borderBottomWidth: 1,
    borderColor: COLOR.accent,
    paddingHorizontal: 25,
    paddingVertical: 10,
    backgroundColor: 'rgb(248, 248, 248)',
    height: 100,
    overflow: 'hidden',
    transition: 'height 0.2s ease-in-out',
  },
  moreInfoBtn: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: 'white',
    width: 130,
    paddingLeft: 20,
    paddingVertical: 10,
    borderRadius: 20,
    borderWidth: 1.5,
    marginTop: 10,
    marginBottom: 10,
    marginRight: 15,
    borderColor: COLOR.accent,
    tintColor: 'rgb(17, 152, 200)',
  },
  infoCircle: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: 'rgb(17, 152, 200)',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 5,
  },
});
